import { isEmpty } from 'lodash';
import browserUtils from './browserUtils';

const saveToken = (token: string): void => {
  if (browserUtils.isBrowser()) {
    window.localStorage.setItem('token', token);
  }
};

const deleteToken = (): void => {
  if (browserUtils.isBrowser()) {
    window.localStorage.removeItem('token');
  }
};

const getToken = (): string | null => {
  if (browserUtils.isBrowser()) {
    return window.localStorage.getItem('token');
  }
  return null;
};

const getEasypayToken = (): string | null => {
  if (browserUtils.isBrowser()) {
    return window.localStorage.getItem('easypayToken');
  }
  return null;
};

const clearStorage = () => {
  if (browserUtils.isBrowser()) {
    window.localStorage.clear();
    // const keysToKeep = [
    //   "homePageTourCompleted",
    //   "myProfileTourCompleted",
    //   "attendancePageTourCompleted",
    // ];

    // Object.keys(window.localStorage).forEach((key) => {
    //   if (!keysToKeep.includes(key)) {
    //     localStorage.removeItem(key);
    //   }
    // });
  }
};

const isAuthenticated = (): boolean => !isEmpty(getToken());

const getDeviceId = (): string | null => {
  return localStorage.getItem('deviceId');
};

const saveEasypayToken = (token: string): void => {
  if (browserUtils.isBrowser()) {
    window.localStorage.setItem('easypayToken', token);
  }
};

const authenticationUtils = {
  saveToken,
  isAuthenticated,
  getToken,
  getEasypayToken,
  deleteToken,
  clearStorage,
  getDeviceId,
  saveEasypayToken
};

export default authenticationUtils;
